import { render, staticRenderFns } from "./stockTakingTwo.vue?vue&type=template&id=41665a96&scoped=true"
import script from "./stockTakingTwo.vue?vue&type=script&lang=js"
export * from "./stockTakingTwo.vue?vue&type=script&lang=js"
import style0 from "./stockTakingTwo.vue?vue&type=style&index=0&id=41665a96&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41665a96",
  null
  
)

export default component.exports